import React from 'react';

const DataLostSvg = ({ width = 206, height = 142, className = "" }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 206 142" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.62" filter="url(#filter0_f_10651_13655)">
        <path 
          d="M46.5645 121.562C85.6331 151.7 86.41 111.513 150.157 135.028C213.904 158.544 216.434 53.9668 176.668 24.9811C134.587 -5.69166 50.0051 -1.05691 21.0028 19.2813C-23.8007 50.7004 26.7151 106.25 46.5645 121.562Z" 
          fill="#E6E6E6"
        />
      </g>
      <g filter="url(#filter1_i_10651_13655)">
        <path 
          d="M103.698 16.6236C106.758 11.1971 114.573 11.1971 117.634 16.6236L159.633 91.0872C162.641 96.4201 158.788 103.017 152.665 103.017H68.6659C62.5431 103.017 58.6899 96.4201 61.6978 91.0872L103.698 16.6236Z" 
          fill="#FFA525"
        />
      </g>
      <g filter="url(#filter2_di_10651_13655)">
        <path 
          d="M103.302 39.6363C103.302 35.2981 106.819 31.7812 111.157 31.7812C115.495 31.7812 119.012 35.2981 119.012 39.6363V59.9262C119.012 64.2644 115.495 67.7812 111.157 67.7812C106.819 67.7812 103.302 64.2644 103.302 59.9262V39.6363Z" 
          fill="#995A00"
        />
      </g>
      <path 
        d="M105.302 42.2812C105.302 40.9005 106.421 39.7812 107.802 39.7812C109.182 39.7812 110.302 40.9005 110.302 42.2812V49.2812C110.302 50.662 109.182 51.7812 107.802 51.7812C106.421 51.7812 105.302 50.662 105.302 49.2812V42.2812Z" 
        fill="white"
      />
      <g filter="url(#filter3_di_10651_13655)">
        <path 
          d="M103.302 85.6363C103.302 81.2981 106.819 77.7812 111.157 77.7812C115.495 77.7812 119.012 81.2981 119.012 85.6363V85.9262C119.012 90.2644 115.495 93.7812 111.157 93.7812C106.819 93.7812 103.302 90.2644 103.302 85.9262V85.6363Z" 
          fill="#995A00"
        />
      </g>
      <path 
        d="M76.5455 73.2106C77.2232 72.0361 78.7242 71.6339 79.8983 72.3122C81.0724 72.9905 81.4748 74.4925 80.7972 75.667L77.3598 81.6249C76.6822 82.7994 75.1811 83.2016 74.007 82.5233C72.833 81.845 72.4305 80.343 73.1081 79.1685L76.5455 73.2106Z" 
        fill="white"
      />
      <path 
        d="M178.737 52.1213C178.686 52.1213 178.35 52.2992 177.791 52.7343C177.216 53.1815 177.149 54.2503 177.16 55.3181C177.17 56.1678 177.606 56.8308 178.066 57.4221C178.544 58.037 179.349 58.3249 180.233 58.4917C181.231 58.6799 182.172 58.4721 182.933 58.0975C183.792 57.675 184.295 56.8921 184.653 56.293C185.011 55.6927 185.014 54.6751 184.911 53.5537C184.827 52.6406 184.131 52.0851 183.559 51.6419C182.126 50.9864 181.006 50.9052 180.356 51.1351C180.042 51.2888 179.758 51.5176 179.153 51.9845" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M118.719 124.726C118.667 124.726 118.331 124.904 117.772 125.339C117.198 125.786 117.13 126.855 117.142 127.923C117.151 128.772 117.588 129.435 118.047 130.027C118.525 130.641 119.33 130.929 120.214 131.096C121.213 131.284 122.154 131.077 122.915 130.702C123.773 130.28 124.276 129.497 124.634 128.897C124.993 128.297 124.995 127.28 124.892 126.158C124.808 125.245 124.112 124.69 123.541 124.246C122.108 123.591 120.987 123.51 120.338 123.74C120.023 123.893 119.739 124.122 119.135 124.589" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M47.1162 38.3564C47.7228 38.7796 48.678 39.4911 49.9523 40.4219C51.887 41.8352 52.7121 42.5138 53.3861 43.2403C53.5504 43.415 53.7431 43.5944 53.8814 43.7179C54.0196 43.8414 54.0977 43.9035 54.2776 44.0394" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M47.5635 45.2469C47.8336 44.9665 48.585 44.1806 48.8854 43.7779C49.4329 43.0439 49.7397 42.3384 50.4043 41.401C51.1308 40.3762 51.5363 39.7692 51.9566 39.1968C52.5103 38.4425 52.8407 38.1229 53.1545 37.7843C53.2253 37.7057 53.2823 37.6413 53.3431 37.5791C53.404 37.517 53.4672 37.459 53.6852 37.2627" 
        stroke="#333333" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <g filter="url(#filter4_in_10651_13655)">
        <path 
          d="M55.8416 114.866L57.4416 113.553C58.4435 112.731 58.4109 111.188 57.3751 110.409L54.1786 108.004C53.4415 107.45 52.4208 107.471 51.7077 108.056L49.3551 109.987L47.2657 108.415C46.9378 108.169 46.5386 108.035 46.1284 108.035C45.6978 108.035 45.2802 108.182 44.9444 108.452L44.59 108.736C44.1168 109.116 43.8416 109.689 43.8416 110.296V111.283C43.8416 111.902 44.1276 112.485 44.6165 112.864L55.287 121.133C55.6405 121.407 56.1068 121.488 56.532 121.35C57.0874 121.168 57.4632 120.651 57.4632 120.066V116.972C57.4632 116.271 57.0956 115.62 56.4944 115.259L55.8416 114.866Z" 
          fill="#8C8C8C"
        />
      </g>
      <g filter="url(#filter5_in_10651_13655)">
        <path 
          d="M22.6702 131.887L44.9974 113.052L53.4922 119.678L30.9912 140.032C29.5904 141.299 27.7688 142 25.8799 142H24.6375C23.5679 142 22.5357 141.607 21.7373 140.895C20.6838 139.956 20.1503 138.565 20.3057 137.162L20.4237 136.097C20.6053 134.457 21.4095 132.95 22.6702 131.887Z" 
          fill="#666666"
        />
      </g>
      <path 
        d="M30.4953 137.37C31.144 137.261 49.3062 121.106 49.6305 120.456C49.9549 119.805 49.3062 119.48 48.6576 119.805C48.0089 120.131 29.1617 134.442 28.8374 136.069C28.5131 137.695 30.4953 137.37 30.4953 137.37Z" 
        fill="#D9D9D9"
      />
      <path 
        d="M74.3281 64.7754C59.0418 64.7755 45.1387 75.7696 45.1387 91.1221C45.1389 106.474 59.0419 117.468 74.3281 117.468C89.6144 117.468 103.517 106.474 103.518 91.1221C103.518 75.7695 89.6145 64.7754 74.3281 64.7754ZM74.3281 69.3291C87.9412 69.3291 98.9766 78.5041 98.9766 89.8213C98.9763 101.138 87.9411 110.312 74.3281 110.312C60.7151 110.312 49.6799 101.138 49.6797 89.8213C49.6797 78.5041 60.715 69.3291 74.3281 69.3291Z" 
        fill="#333333"
      />
      <path 
        d="M74.3281 64.7754C59.042 64.7755 45.1389 75.2262 45.1387 89.8203C45.1387 104.415 59.0418 114.866 74.3281 114.866C89.6145 114.866 103.518 104.415 103.518 89.8203C103.517 75.2261 89.6143 64.7754 74.3281 64.7754ZM74.5449 69.1123C88.1579 69.1123 99.1931 78.2865 99.1934 89.6035C99.1934 100.921 88.158 110.096 74.5449 110.096C60.9318 110.096 49.8965 100.921 49.8965 89.6035C49.8967 78.2865 60.932 69.1123 74.5449 69.1123Z" 
        fill="#666666"
      />
      <foreignObject x="9.89551" y="29.1123" width="129.298" height="120.983">
        <div 
          xmlns="http://www.w3.org/1999/xhtml" 
          style={{
            backdropFilter: 'blur(20px)',
            clipPath: 'url(#bgblur_0_10651_13655_clip_path)',
            height: '100%',
            width: '100%'
          }}
        />
      </foreignObject>
      <g opacity="0.5" filter="url(#filter6_i_10651_13655)" data-figma-bg-blur-radius="40">
        <ellipse 
          cx="24.6487" 
          cy="20.4916" 
          rx="24.6487" 
          ry="20.4916" 
          transform="matrix(-1 0 0 1 99.1934 69.1123)" 
          fill="white" 
          fillOpacity="0.5"
        />
      </g>
      <path 
        d="M56.069 115.791L55.7987 115.907C55.4315 116.065 55.1936 116.426 55.1936 116.826V120.37C55.1936 121.035 55.8301 121.514 56.4691 121.331L56.7394 121.254C57.1683 121.131 57.4639 120.739 57.4639 120.292V116.71C57.4639 115.991 56.729 115.507 56.069 115.791Z" 
        fill="#666666"
      />
      
      <defs>
        <filter 
          id="filter0_f_10651_13655" 
          x="0" 
          y="0" 
          width="206" 
          height="141.444" 
          filterUnits="userSpaceOnUse" 
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur_10651_13655"/>
        </filter>
        <filter 
          id="filter1_i_10651_13655" 
          x="60.6543" 
          y="12.5537" 
          width="100.022" 
          height="90.4639" 
          filterUnits="userSpaceOnUse" 
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="-16"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.588235 0 0 0 0 0 0 0 0 1 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_10651_13655"/>
        </filter>
        <filter 
          id="filter2_di_10651_13655" 
          x="103.302" 
          y="31.7812" 
          width="18.71" 
          height="39" 
          filterUnits="userSpaceOnUse" 
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="3" dy="3"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10651_13655"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10651_13655" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="-5" dy="-5"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_10651_13655"/>
        </filter>
        <filter 
          id="filter3_di_10651_13655" 
          x="103.302" 
          y="77.7812" 
          width="18.71" 
          height="19" 
          filterUnits="userSpaceOnUse" 
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="3" dy="3"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10651_13655"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_10651_13655" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="-5" dy="-5"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_10651_13655"/>
        </filter>
        <filter 
          id="filter4_in_10651_13655" 
          x="39.8418" 
          y="107.603" 
          width="18.3311" 
          height="13.8135" 
          filterUnits="userSpaceOnUse" 
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="-4"/>
          <feGaussianBlur stdDeviation="4"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_10651_13655"/>
          <feTurbulence type="fractalNoise" baseFrequency="10 10" stitchTiles="stitch" numOctaves="3" result="noise" seed="702" />
          <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
          <feComponentTransfer in="alphaNoise" result="coloredNoise1">
            <feFuncA type="discrete" tableValues="0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "/>
          </feComponentTransfer>
          <feComposite operator="in" in2="effect1_innerShadow_10651_13655" in="coloredNoise1" result="noise1Clipped" />
          <feFlood floodColor="rgba(0, 0, 0, 0.2)" result="color1Flood" />
          <feComposite operator="in" in2="noise1Clipped" in="color1Flood" result="color1" />
          <feMerge result="effect2_noise_10651_13655">
            <feMergeNode in="effect1_innerShadow_10651_13655" />
            <feMergeNode in="color1" />
          </feMerge>
        </filter>
        <filter 
          id="filter5_in_10651_13655" 
          x="16.2793" 
          y="113.052" 
          width="37.2129" 
          height="28.9482" 
          filterUnits="userSpaceOnUse" 
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="-4"/>
          <feGaussianBlur stdDeviation="4"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_10651_13655"/>
          <feTurbulence type="fractalNoise" baseFrequency="10 10" stitchTiles="stitch" numOctaves="3" result="noise" seed="702" />
          <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
          <feComponentTransfer in="alphaNoise" result="coloredNoise1">
            <feFuncA type="discrete" tableValues="0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "/>
          </feComponentTransfer>
          <feComposite operator="in" in2="effect1_innerShadow_10651_13655" in="coloredNoise1" result="noise1Clipped" />
          <feFlood floodColor="rgba(0, 0, 0, 0.2)" result="color1Flood" />
          <feComposite operator="in" in2="noise1Clipped" in="color1Flood" result="color1" />
          <feMerge result="effect2_noise_10651_13655">
            <feMergeNode in="effect1_innerShadow_10651_13655" />
            <feMergeNode in="color1" />
          </feMerge>
        </filter>
        <filter 
          id="filter6_i_10651_13655" 
          x="9.89551" 
          y="29.1123" 
          width="129.298" 
          height="120.983" 
          filterUnits="userSpaceOnUse" 
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_10651_13655"/>
        </filter>
        <clipPath id="bgblur_0_10651_13655_clip_path" transform="translate(-9.89551 -29.1123)">
          <ellipse 
            cx="24.6487" 
            cy="20.4916" 
            rx="24.6487" 
            ry="20.4916" 
            transform="matrix(-1 0 0 1 99.1934 69.1123)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DataLostSvg;